import postFetcher from 'api/utils/postFetcher';
import { useCallback } from 'react';

interface UseSimProfileEnableProps {
  hologramSimId?: HologramSimId;
  simProfileId?: ProfileId;
}

const useSimProfileEnableCall = ({ hologramSimId, simProfileId }: UseSimProfileEnableProps) => {
  const url =
    hologramSimId && simProfileId
      ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${hologramSimId}/profiles/${simProfileId}/enable`
      : null;

  const callback = useCallback(async () => {
    if (!url) {
      return undefined;
    }

    const result: void = await postFetcher({
      url,
      body: null,
    });

    return result;
  }, [url]);

  return callback;
};

export default useSimProfileEnableCall;
